<template>
  <div>
    <SOSlotModal :modal-title="`Tolak Penghapusan`" :modal-id="`modal${dataId}`" @close="back">
      <template v-slot:modal-body>
        <form class="modal-tolak-transaksi">
          <div class="form-group">
            <div>
              <label>Tolak permintaan transaksi ini?</label>
            </div>
            <div class="m-t-12">
              <SOInputRegular
                :title="'Alasan'"
                :placeholder="'Alasan'"
                :validation="'alphanumeric'"
                :required="true"
                v-model="keterangan"
                @input="handleInput($event)"
              />
              <ErrorMessage class="error" label="Alasan" :validation="$v.keterangan" />
            </div>
          </div>
        </form>
      </template>
      <template v-slot:modal-footer>
        <SOButton
          :outline="true"
          :full="true"
          :text="'Tolak'"
          :id="dataId"
          :disable="isFetching"
          :loading="isFetching"
          @action="onTolak"
        />
      </template>
    </SOSlotModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOButton from "@/so-components/global/ui/SOButton";
import ErrorMessage from "@/component-items/ErrorMessage";
import { minLength, required } from "vuelidate/lib/validators";

import { moduleName } from "../store/state";

export default {
  name: "SOTolakModal",
  components: {
    SOSlotModal,
    SOInputRegular,
    ErrorMessage,
    SOButton,
  },
  data() {
    return {
      keterangan: "",
      isClick: false,
      backLink: "PembatalanTransaksiSnapclean.list",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setBackLink(from.name);
    });
  },
  validations: {
    keterangan: {
      required,
      minLength: minLength(2),
    },
  },
  mounted() {
    $(`#modal${this.dataId}`).modal("show");
  },
  computed: {
    ...mapGetters(moduleName, {
      response: "getResponse",
      isFetching: "isFecthing",
      dataDetail: "dataDetail",
    }),
    dataId() {
      return this.dataDetail.idhapus.toString();
    },
  },
  watch: {
    response(newRes, oldRes) {
      if (this.isClick && newRes !== oldRes) {
        this.isClick = false;
        this.closeModal();
        if (newRes.success === true) {
          this.$router.push({
            name: "PembatalanTransaksiSnapclean.detail.data",
            params: { id: this.dataId },
          });
        } else {
          this.back();
        }
      }
    },
  },
  props: {
    useRoutePush: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions({
      loadDetail: `${moduleName}/loadDetail`,
      updatePembatalan: `${moduleName}/updatePembatalan`,
    }),
    back() {
      this.closeModal();
      this.useRoutePush ? this.$router.push({ name: this.backLink }) : this.$emit("close");
    },
    closeModal() {
      $(`#modal${this.dataId}`).modal("hide");
    },
    setBackLink(routeBack) {
      this.backLink = routeBack;
    },
    handleInput(val) {
      this.keterangan = val;
    },
    errorValidation() {
      this.$v.keterangan.$touch();
      return this.$v.keterangan.$invalid;
    },
    onTolak() {
      if (this.errorValidation()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }

      this.isClick = true;
      this.updatePembatalan({
        keterangan_status: this.keterangan,
        idpermintaanhapus: this.dataDetail.idhapus,
        idtransaksi: this.dataDetail.idtransaksi,
        action: "decline",
      });
    },
  },
};
</script>

<style scoped>
.modal-tolak-transaksi .form-group {
  margin-top: 0px;
  margin-bottom: 0px;
}

div.modal-dialog div div[class="modal-body"] {
  border-top: 1px solid #ededed;
}
</style>
